import { Uuid, UuidString } from '~src/utils/UUID';
import { z } from 'zod';

export const UserGroupInfo = z.object({
  group_id: z
    .string()
    .uuid()
    .transform((u) => Uuid.from_string(u)),
  alias: z.string(),
});
export type UserGroupInfo = z.infer<typeof UserGroupInfo>;

export const Cohort = z
  .object({})
  .catchall(UserGroupInfo.array())
  .transform((o) => {
    let asMap = new Map<UuidString, UserGroupInfo[]>();

    for (const [user_id, group_infos] of Object.entries(o)) {
      asMap.set(Uuid.from_string(user_id), group_infos);
    }

    return asMap;
  });

export type Cohort = z.infer<typeof Cohort>;
